module.exports = __webpack_public_path__ + "img/logo-intl.ed70c91.webp";